export const getTickIntervalAndFormat = (timeWindowMs,widget,MOBILE_COMPUTER_SCREEN_BOUNDARY,bounds) => {
    let tickIntervalMs;
    let format;
    const screenIsMobileScreen = () => {
        return bounds.width < MOBILE_COMPUTER_SCREEN_BOUNDARY;
    };
    switch(timeWindowMs){
        case 1000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 5000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour:'2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 10000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 2000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour:'2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 15000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 2000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour:'2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 30000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 4000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour:'2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 60000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 10000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour:'2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 120000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 20000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour:'2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        break;
        case 300000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 60 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 450000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 60 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 600000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 60 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 900000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 120 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 1800000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 120 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 3600000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 300 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 7200000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 600 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 18000000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 1800 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 36000000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 3600 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 43200000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 4800 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 86400000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 7200 * 1000;
            format = ts => new Date(ts).toLocaleTimeString('en-KE', {
                hour: '2-digit', minute: '2-digit', hour12: false
            });
        break;
        case 604800000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 24 * 3600 * 1000;
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 2592000000:
            tickIntervalMs = (screenIsMobileScreen()? 2:widget?.sizeX < 7? (widget?.sizeX < 4? 3:2):1) * 96 * 3600 * 1000;
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 5184000000: // 60d (~2 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 7 * 24 * 3600 * 1000; // 1 week
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 7776000000: // 90d (~3 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 7 * 24 * 3600 * 1000; // 1 week
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 10368000000: // 120d (~4 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 14 * 24 * 3600 * 1000; // 2 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 15552000000: // 180d (~6 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 14 * 24 * 3600 * 1000; // 2 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 18144000000: // 210d (~7 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 21 * 24 * 3600 * 1000; // 3 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 20736000000: // 240d (~8 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 21 * 24 * 3600 * 1000; // 3 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 23328000000: // 270d (~9 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 28 * 24 * 3600 * 1000; // 4 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 25920000000: // 300d (~10 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 28 * 24 * 3600 * 1000; // 4 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 28512000000: // 330d (~11 months)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 28 * 24 * 3600 * 1000; // 4 weeks
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        case 31536000000: // 365d (~1 year)
            tickIntervalMs = (screenIsMobileScreen() ? 2 : widget?.sizeX < 7 ? (widget?.sizeX < 4 ? 3 : 2) : 1) * 30 * 24 * 3600 * 1000; // 1 month
            format = ts => new Date(ts).toLocaleDateString('en-KE', {
                month: 'short', day: 'numeric'
            });
        break;
        default:
            tickIntervalMs = Math.ceil(timeWindowMs / 6);
            format = ts => new Date(ts).toLocaleString('en-KE');
        break;
    }
    return { tickIntervalMs, format };
};